// RubricsModal.tsx
import React from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import EditableJson from "../components/EditableJson";
import { CustomModal } from "./CustomeModal";

interface RubricsModalProps {
  open: boolean;
  onClose: () => void;
  rubrics: any;
  onDownload: () => void;
  onUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSave: (rubrics: any) => void;
  isSubmitting: boolean;
  isPublished: boolean;
}

export const RubricsModal: React.FC<RubricsModalProps> = ({
  open,
  onClose,
  rubrics,
  onDownload,
  onUpload,
  onSave,
  isSubmitting,
  isPublished,
}) => {
  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title={isPublished ? "View Rubrics" : "Edit Rubrics"}
    >
      <Button variant="text" color="primary" onClick={onDownload}>
        Download Rubrics
      </Button>
      <Box gap={2} mt={2} mb={2}>
        <Button
          variant="outlined"
          component="label"
          color="primary"
          disabled={isPublished}
        >
          Upload Rubrics
          <input type="file" hidden onChange={onUpload} />
        </Button>
      </Box>
      {rubrics?.rubric && (
        <EditableJson
          isSubmitting={isSubmitting}
          saveRubrics={(newRubrics) => !isPublished && onSave(newRubrics)}
          initialJson={rubrics.rubric}
          key={JSON.stringify(rubrics.rubric)}
          isPublished={isPublished}
        />
      )}
    </CustomModal>
  );
};
